module.exports = __webpack_public_path__ + "853e5ddbae1c6da8c3d22e75797abbef.svg";